export const SET_USER_ID = 'USER/SET_USER_ID'
export const SET_USER_COOKIES = 'USER/SET_USER_COOKIES'
export const SET_USER_WEB_CONVERSION = 'USER/SET_USER_WEB_CONVERSION'
export const SET_USER_GCLID_CONVERSION = 'USER/SET_USER_GCLID_CONVERSION'

/**
 * @param {string} id
 */
export const setUserId = id => ({
  type: SET_USER_ID,
  payload: { id },
})

/**
 * @param {boolean} cookies
 */
export const setUserCookies = cookies => ({
  type: SET_USER_COOKIES,
  payload: { cookies },
})

/**
 * @param {boolean} isWebConversionSended
 */
export const setUserWebConversion = isWebConversionSended => ({
  type: SET_USER_WEB_CONVERSION,
  payload: { isWebConversionSended },
})

/**
 * @param {boolean} isGclidConversionSended
 */
export const setUserGclidConversion = isGclidConversionSended => ({
  type: SET_USER_GCLID_CONVERSION,
  payload: { isGclidConversionSended },
})
